import { createBrowserRouter, Navigate } from 'react-router'
import LoginPage from '@/features/auth/components/LoginPage'
import { Home } from '@/features/home/components/HomePage'
import TransferPage from '@/features/transfer/components/TransferPage'
import { ProtectedRoute } from '@/shared/components/ProtectedRoute'
import { PublicRoute } from '@/shared/components/PublicRoute'
import { SLIM_ROUTES } from '@/shared/routes'

export const router = createBrowserRouter([
  {
    element: <PublicRoute />,
    children: [{ path: SLIM_ROUTES.LOGIN, element: <LoginPage /> }],
  },
  {
    element: <ProtectedRoute />,
    children: [
      { path: SLIM_ROUTES.HOME, element: <Home /> },
      { path: SLIM_ROUTES.TRANSFER, element: <TransferPage /> },
    ],
  },
  { path: '*', element: <Navigate to={SLIM_ROUTES.HOME} replace /> },
])
